<div *ngIf="employeeHomepageHeader && balances != null" class="headerGrid">
  <div>
    <h3 class="fw-bold">Time Off</h3>
    <h3>
      {{ collectiveAvailableBalance | async | number: '1.2' }} hour<span
        *ngIf="(collectiveAvailableBalance | async) != 1"
        >s</span
      >
      available
    </h3>
  </div>
  <div class="card w-100">
    <div class="p-1 cardGrid">
      <div>
        <ng-container *ngFor="let balance of balances | async">
          <div class="d-flex justify-content-between" *ngIf="getPtoActive(balance.PlanId) | async">
            <span>Available {{ getPtoName(balance.PlanId) | async }} :</span>
            <span
              >{{ balance.Balance | number: '1.2' }} hour<span *ngIf="balance.Balance != 1"
                >s</span
              ></span
            >
          </div>
        </ng-container>
      </div>
      <div class="cardGridItem ps-3">
        <div class="d-flex justify-content-between">
          <span><span class="circle pendingChangeTextBackground"></span> Requested:</span>
          <span
            >{{ collectiveRequested | async | number: '1.2' }} hour<span
              *ngIf="(collectiveRequested | async) != 1"
              >s</span
            ></span
          >
        </div>
        <div class="d-flex justify-content-between">
          <span><span class="circle pendingChangeBackground"></span> Pending Change:</span>
          <span
            >{{ collectivePendingChange | async | number: '1.2' }} hour<span
              *ngIf="(collectivePendingChange | async) != 1"
              >s</span
            ></span
          >
        </div>
        <div class="d-flex justify-content-between">
          <span><span class="circle bg-connectpay"></span> Approved:</span>
          <span
            >{{ collectiveApproved | async | number: '1.2' }} hour<span
              *ngIf="(collectiveApproved | async) != 1"
              >s</span
            ></span
          >
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="!employeeHomepageHeader">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <span>Accrued: </span><span>{{ accruedBalance | async | number: '1.2' }}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span>Used: </span><span>{{ usedBalance | async | number: '1.2' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <span>Balance: </span><span>{{ currentBalance | async | number: '1.2' }}</span>
          </div>
          <ul>
            <li>
              <div class="d-flex justify-content-between">
                <span>Requested:</span><span>{{ requestedHours | async | number: '1.2' }}</span>
              </div>
            </li>
            <li>
              <div class="d-flex justify-content-between">
                <span>Pending Change:</span><span>{{ pendingChange | async | number: '1.2' }}</span>
              </div>
            </li>
            <li>
              <div class="d-flex justify-content-between">
                <span>Approved: </span><span>{{ approvedBalance | async | number: '1.2' }}</span>
              </div>
            </li>
          </ul>
          <div class="d-flex justify-content-between">
            <span>Available Balance: </span
            ><span>{{ availableBalance | async | number: '1.2' }}</span>
          </div>
          <ul>
            <li>
              <div class="d-flex justify-content-between">
                <span>Current Request:</span>
                <span>{{ currentRequestHours | async | number: '1.2' }}</span>
              </div>
            </li>
          </ul>
          <div
            class="d-flex justify-content-between"
            [class.text-danger]="(remainingBalance | async) < 0">
            <span>Remaining Balance: </span
            ><span>{{ remainingBalance | async | number: '1.2' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
